import { useEffect } from 'react'
import type { LanguageCode } from '../data/languages'
import { applySeo, type PageSeo } from '../data/seoTags'

/** Applies per-page SEO tags whenever the resolved values change. Pass `null` while data is still loading. */
export function useDocumentSeo(seo: PageSeo | null, language: LanguageCode) {
  useEffect(() => {
    if (!seo) return
    applySeo(seo, language)
    // Depend on primitive fields, not `seo`'s object identity — callers
    // commonly pass a freshly-built literal on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seo?.title, seo?.description, seo?.canonical, seo?.image, seo?.noindex, seo?.rawTitle, language])
}
